
export const getZoomEmbedUrl = (meetingId: string, userName?: string) => {
  if (!meetingId) return "";
  
  const cleanInput = meetingId.trim().replace(/\s/g, '');
  const encodedName = userName ? btoa(encodeURIComponent(userName)) : 'QWR2ZW50dXJlcg==';
  
  // Hvis det er et fuldt link
  if (cleanInput.startsWith('http')) {
    const url = new URL(cleanInput);
    const domain = url.hostname;
    const pathParts = url.pathname.split('/');
    const id = pathParts[pathParts.length - 1] || url.searchParams.get('j');

    if (id) {
      // Vi bruger /wc/join formatet som er designet til iframes
      return `https://${domain}/wc/join/${id}?prefer=1&un=${encodedName}`;
    }
    return cleanInput;
  }
  
  // Hvis det bare er et rent ID
  return `https://zoom.us/wc/join/${cleanInput}?prefer=1&un=${encodedName}`; 
};

export const initZoomSDK = async (meetingNumber: string, password: string, userName: string) => {
  return { success: true };
};
